module.exports = __webpack_public_path__ + "img/mobil-dispatch-logo.ac0b5c06.png";